import React from "react";

import { ChangePasswordForm } from "@/pages/profile/ChangePasswordForm";
import { ConnectionsManager } from "@/pages/profile/ConnectionsManager";
import { useAuth } from "@/auth/useAuth";

export function ProfilePage(): React.ReactElement {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Профиль</h1>
        <p className="text-muted-foreground">Пользователь: {user?.username}</p>
      </div>
      <div className="max-w-lg">
        <ChangePasswordForm />
      </div>
      <ConnectionsManager />
    </div>
  );
}
